/** Throws when `condition` is falsy; narrows it to truthy for the compiler otherwise. */
export function assert(condition: unknown, message: string): asserts condition {
  if (!condition) {
    throw new Error(message);
  }
}
